const KEY = "@PreApprovalsSearch/";
export const SEARCH_DATA_LOADED = `${KEY}SEARCH_DATA_LOADED`;
